export type Environment = "development" | "staging" | "production";

interface EnvironmentConfig {
  ENV: Environment;
  API_URL: string;
  APP_NAME: string;
  ENABLE_OFFLINE: boolean;
  DEBUG_MODE: boolean;
  IS_PRODUCTION: boolean;
  IS_DEVELOPMENT: boolean;
}

const parseBoolean = (
  value: string | undefined,
  defaultValue = false
): boolean => {
  if (!value) return defaultValue;
  return value.toLowerCase() === "true";
};

const getCurrentEnvironment = (): Environment => {
  const env = import.meta.env.VITE_ENV || import.meta.env.MODE || "development";
  return env as Environment;
};

const currentEnv = getCurrentEnvironment();

export const env: EnvironmentConfig = {
  ENV: currentEnv,
  API_URL: import.meta.env.VITE_API_URL || "/api",
  APP_NAME: "Poultry Book",
  ENABLE_OFFLINE: parseBoolean(import.meta.env.VITE_ENABLE_OFFLINE, true),
  DEBUG_MODE: parseBoolean(
    import.meta.env.VITE_DEBUG_MODE,
    currentEnv === "development"
  ),
  IS_PRODUCTION: currentEnv === "production",
  IS_DEVELOPMENT: currentEnv === "development",
};

export const isProduction = (): boolean => env.IS_PRODUCTION;
export const isDevelopment = (): boolean => env.IS_DEVELOPMENT;

export default env;
